import Vue from 'vue'
import Vuex from 'vuex'

import LocalCache from '@/utils/cache'
import router from '@/router'
import { accountLogin } from '@/service/login/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    token: ''
  },
  getters: {},
  mutations: {
    setUserInfo(state, userInfo) {
      // console.log('userinfo', userInfo)
      state.userInfo = userInfo
    },
    setToken(state, token) {
      state.token = token
    }
  },
  actions: {
    accountLoginAction({ commit }, payload) {
      const loginForm = payload.loginForm
      accountLogin(loginForm).then((res) => {
        const { _this } = payload
        if (res.code === 0) {
          const token = res.token
          commit('setUserInfo', loginForm)
          commit('setToken', token)
          LocalCache.setCache('userinfo', loginForm)
          LocalCache.setCache('token', token)
          router.push('/home')
          _this.$Message.success('登录成功')
        } else {
          _this.$Message.error(res.msg)
        }
      })
    }
  },
  modules: {}
})
